import { render, staticRenderFns } from "./CustomDisplay.vue?vue&type=template&id=fd318530&"
import script from "./CustomDisplay.vue?vue&type=script&lang=js&"
export * from "./CustomDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports